import { LoadingContainer, Model } from 'peach/components'
import { Page } from 'core/components'
import { useParams, useRouteMatch, useHistory } from 'peach/router'
import { useClickAction } from 'peach/decorators/withActionTrigger'

import { R } from 'core/helpers'
import { useGetWorkitemTypes } from 'core/types'

const WorkflowItemTypes = () => {
  const { companyId } = useParams<{ companyId?: string }>()
  const { url } = useRouteMatch()
  const history = useHistory()

  const { data: workitemTypes, isLoading } = useGetWorkitemTypes({ companyId })

  useClickAction({
    label: 'Create Workflow Item Type',
    onClick: () => history.push(`${url}/create-workflow-item-type`),
  })

  const sorted = R.sortBy(workitemTypes ?? [], (t) => t.createdAt!)

  return (
    <LoadingContainer isLoading={isLoading}>
      <Page variant='full'>
        <Model.List
          json={sorted}
          title='Workflow Item Types'
          withDetails
          withRelated
          withTimestamps
        />
      </Page>
    </LoadingContainer>
  )
}

export default WorkflowItemTypes
